import React from 'react';

export function FeeTipV1() {
  return (
    <div className="border border-greenLight bg-greenLight bg-opacity-20 rounded-lg text-sm text-white px-3 py-2 my-3">
      👀 Fees automatically contribute to your liquidity for market making.
    </div>
  );
}
export function FeeTipDcl() {
  return (
    <div className="border border-greenLight bg-greenLight bg-opacity-20 rounded-lg text-sm text-white px-3 py-2 mt-4">
      👀 Claim your fees on the "Your Liquidity" page.
    </div>
  );
}
